// extracted by mini-css-extract-plugin
export var billingAddress = "_qw-g";
export var contactInfo = "_qw-d";
export var customerInfoContainer = "_qw-c";
export var customerInfoContainerMobile = "_qw-h";
export var customerInfoRow = "_qw-a";
export var customerInfoSection = "_qw-b";
export var fullWidthDividerMobile = "_qw-i";
export var imageContainer = "_qw-1";
export var paymentMethod = "_qw-e";
export var priceText = "_qw-6";
export var priceTextMobile = "_qw-7";
export var product = "_qw-0";
export var productImage = "_qw-2";
export var productInfo = "_qw-4";
export var productMobile = "_qw-9";
export var productTitle = "_qw-8";
export var quantityBadge = "_qw-3";
export var quantityText = "_qw-5";
export var shippingAddress = "_qw-f";